import { SVGProps, Ref, forwardRef } from 'react'
const SvgPrint = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.25 17.249h-3a1.5 1.5 0 0 1-1.5-1.5v-7.5a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-3M3.75 9.749h1.5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.25 12.749h13.5v10.5H5.25v-10.5ZM18.5 7H5V2.5A1.5 1.5 0 0 1 6.5 1H17a1.5 1.5 0 0 1 1.5 1.5V7ZM8.25 15.749h7.5M8.25 18.749h5.25"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPrint)
export default ForwardRef
